<div id="infrastructure">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                    <h4 class="card-title">Hostel Facility</h4>
                        <p class="inner-lead">The Institute has separate hostels for boys and girls. The hostel is well guarded by the institute’s own security. The seats are on first come first serve basis. The mess is run on co-operative basis by the mess committee of resident students and adheres to the strict standards of hygiene.</p>
                    </div>
                </div>
            </div>
        </div>